import { Card, CardContent } from '@/components/ui/card';
import EnclosurePreview from '../EnclosurePreview';
import { enclosureTypes } from '../constants';

const EnclosureStep = ({ config, updateConfig }) => (
  <div>
    <h3 className="text-xl font-semibold mb-6">Select Your Enclosure Type</h3>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {enclosureTypes.map((type) => (
        <Card
          key={type.id}
          data-testid={`enclosure-${type.id}`}
          className={`cursor-pointer transition-all hover:shadow-lg ${
            config.enclosureType === type.id
              ? 'ring-2 ring-primary shadow-lg'
              : 'hover:ring-1 hover:ring-primary/50'
          }`}
          onClick={() => updateConfig('enclosureType', type.id)}
        >
          <CardContent className="p-4">
            <div className="aspect-square mb-3">
              <EnclosurePreview type={type.id} />
            </div>
            <h4 className="font-semibold text-center">{type.name}</h4>
            <p className="text-xs text-muted-foreground text-center mt-1">{type.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default EnclosureStep;
